import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_component_is_mounted_300 } from '@/hooks/is_mounted/use_component_is_mounted_300';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { Avatar, AvatarFallback, AvatarImage } from '@radix-ui/react-avatar';
import { get_avatar_fallback_from_name } from '@shared/utils/utils_string';
import { useState } from 'react';

interface Props {
  url_relative: string;
  userName: string;
  className?: string;
  style?: React.CSSProperties;
}

export function UserAvatarReadOnly({ url_relative, userName, className, style }: Props) {
  const [fallback, setFallback] = useState('');

  const { is_mounted } = use_component_is_mounted_300();

  /*
   * EFFECTS
   */
  use_effect(() => {
    let fallback_from_name = userName ? get_avatar_fallback_from_name(userName) : '?';

    setFallback(fallback_from_name);
  }, [userName]);

  /*
   * HTML
   */

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={userName ? userName : 'Unknown guest'} delay_duration={0}>
      <Avatar
        className={`hover-animation ${
          is_mounted ? 'opacity-100 scale-100' : 'opacity-0 scale-50'
        } flex items-center justify-center rounded-full border border-component-item-border ${className}`}
        style={style}
      >
        <AvatarImage className="rounded-full" src={path_relative_to_absolute(url_relative)} />
        <AvatarFallback className="!text-[10px] text-bar-foreground">{fallback}</AvatarFallback>
      </Avatar>
    </UI_PRIMITIVE__tooltip>
  );
}
